import { RANK_FAMILY_ORDER, type ClipperRankFamily } from './types';

export function orderRankFamilies({
  families,
  leadingFamilyId,
}: {
  families: ClipperRankFamily[];
  leadingFamilyId?: string | null;
}): ClipperRankFamily[] {
  const byId = new Map(families.map((family) => [family.id, family]));
  const ordered: ClipperRankFamily[] = [];

  if (leadingFamilyId) {
    const leading = byId.get(leadingFamilyId);
    if (leading) {
      ordered.push(leading);
      byId.delete(leadingFamilyId);
    }
  }

  for (const id of RANK_FAMILY_ORDER) {
    const family = byId.get(id);
    if (family) {
      ordered.push(family);
      byId.delete(id);
    }
  }

  for (const family of byId.values()) {
    ordered.push(family);
  }

  return ordered;
}
